<template>
  <form @submit.prevent="updateSearchTerm">
    <label class="visually-hidden" for="physiciansSearchTerm">
      {{ inputLabel }}
    </label>
    <div class="d-flex justify-content-end mx-n2 flex-wrap">
      <div class="p-2 flex-fill">
        <input
          class="form-control form-control-lg"
          id="physiciansSearchTerm"
          type="search"
          :placeholder="inputPlaceholder"
          v-model="searchTerm"
        >
      </div>
      <div class="p-2">
        <div class="d-flex justify-content-end mx-n1">
          <div class="px-1">
            <button
              class="btn btn-lg btn-white"
              type="submit"
            >
              {{ submitLabel }}
            </button>
          </div>
          <div class="px-1">
            <button
              class="btn btn-lg btn-link text-white text-decoration-underline"
              type="button"
              @click="clearSearchTerm"
            >
              {{ clearLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { ChpPhysiciansStore } from '../stores/ChpPhysiciansStore'

export default {
  props: {
    submitLabel: {
      type: String,
      required: true
    },
    clearLabel: {
      type: String,
      required: true
    },
    inputLabel: {
      type: String,
      required: true
    },
    inputPlaceholder: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      valuesInitialized: false,
      searchTerm: ''
    }
  },
  computed: {
  },
  watch: {
  },
  setup() {
    const store = ChpPhysiciansStore()
    return {
      store
    }
  },
  created() {
  },
  mounted() {
    this.store.$subscribe((mutation, state) => {
      if (!this.valuesInitialized && state.urlParametersStatus === 'ready') {
        this.initializeValues()
      }
    })
  },
  methods: {
    initializeValues() {
      this.valuesInitialized = true
      if (this.store.query.searchTerm) {
        this.searchTerm = this.store.query.searchTerm
      }
    },
    updateSearchTerm() {
      this.store.updateSearchTerm(this.searchTerm)
      const resultsElement = document.querySelector('#physiciansResults')
      if (resultsElement) {
        resultsElement.scrollIntoView(true)
      }
    },
    clearSearchTerm() {
      this.searchTerm = ''
      this.updateSearchTerm()
    }
  },
  components: {
  }
}
</script>